/* NOBL V3.2 — cinematic continuity. No dependencies; safe in Theme Editor. */
(function(){
  'use strict';
  var body=document.body;
  if(!body || body.dataset.noblCinematic!=='true') return;
  var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(){
  if(reduce || body.dataset.noblSectionReveals!=='true') return;

  var nodes=Array.prototype.slice.call(
    document.querySelectorAll('#MainContent > .shopify-section')
  );

  // Announcement + custom nav should behave as chrome, not content reveals.
  // Hero / Trust / Worlds have their own cinematic choreography.
  if(body.classList.contains('template-index')) {

    nodes = nodes.filter(function(n){

      var hasCustomJourney =
        n.querySelector(
          '[data-nobl-hero], [data-nobl-trust], [data-nobl-worlds], [data-nobl-manifesto], [data-nobl-featured]'
        );

      return !hasCustomJourney
        && !n.classList.contains('section-nobl-navigation')
        && !n.classList.contains('section-nobl-announcement');

    });

  }

  nodes.forEach(function(n){
    n.classList.add('nobl-cine-pending');
  });

  if(!('IntersectionObserver' in window)){

    nodes.forEach(function(n){
      n.classList.add('nobl-cine-in');
    });

    return;
  }

  var io=new IntersectionObserver(function(entries){

    entries.forEach(function(e){

      if(e.isIntersecting){

        e.target.classList.add('nobl-cine-in');

        io.unobserve(e.target);

      }

    });

  },{
    threshold:.08,
    rootMargin:'0px 0px -6% 0px'
  });

  nodes.forEach(function(n){
    io.observe(n);
  });
}

  function initEnvironment(){
    if(reduce || body.dataset.noblEnvironmentShift!=='true') return;
    var ticking=false;
    function update(){
      var d=document.documentElement,max=Math.max(1,d.scrollHeight-d.clientHeight),p=Math.min(1,Math.max(0,d.scrollTop/max));
      d.style.setProperty('--nobl-climb',p.toFixed(3));
      d.style.setProperty('--nobl-env-opacity',(p*.72).toFixed(3));
      ticking=false;
    }
    function request(){if(!ticking){requestAnimationFrame(update);ticking=true;}}
    addEventListener('scroll',request,{passive:true});addEventListener('resize',request);update();
  }

  function eligibleLink(a,e){
    if(!a || !a.href || a.target==='_blank' || a.hasAttribute('download')) return false;
    if(e && (e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)) return false;
    if(a.closest('[data-no-nobl-transition],.shopify-payment-button')) return false;
    var u;
    try{u=new URL(a.href,location.href)}catch(_){return false}
    if(u.origin!==location.origin) return false;
    if(u.pathname===location.pathname && u.search===location.search && u.hash) return false;
    if(u.protocol!=='http:' && u.protocol!=='https:') return false;
    return true;
  }
function initHeroMotion(){

  var heroes = document.querySelectorAll(
    '[data-nobl-hero]'
  );

  if(!heroes.length) return;


  heroes.forEach(function(hero){

    if(hero.dataset.noblHeroReady === 'true'){
      return;
    }

    hero.dataset.noblHeroReady = 'true';

    var ticking = false;


    function updateHero(){

      var rect = hero.getBoundingClientRect();

      var height =
        Math.max(
          1,
          hero.offsetHeight
        );

      var progress =
        Math.min(
          1,
          Math.max(
            0,
            -rect.top / height
          )
        );

      hero.style.setProperty(
        '--nobl-hero-progress',
        progress.toFixed(3)
      );

      ticking = false;
    }


    function requestHero(){

      if(ticking) return;

      requestAnimationFrame(
        updateHero
      );

      ticking = true;
    }


    if(!reduce){

      window.addEventListener(
        'scroll',
        requestHero,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        requestHero
      );

      updateHero();

    }


    var cue =
      hero.querySelector(
        '[data-nobl-hero-next]'
      );


    if(cue){

      cue.addEventListener(
        'click',
        function(){

          var wrapper =
            hero.closest(
              '.shopify-section'
            );

          if(!wrapper) return;

          var next =
            wrapper.nextElementSibling;

          if(!next) return;

          next.scrollIntoView({
            behavior:
              reduce
                ? 'auto'
                : 'smooth',

            block: 'start'
          });

        }
      );

    }

  });

}
function initJourneyBridge(){

  var trusts =
    document.querySelectorAll(
      '[data-nobl-trust]'
    );

  var worlds =
    document.querySelectorAll(
      '[data-nobl-worlds]'
    );


  /* ========================================================
     FALLBACK / REDUCED MOTION
     ======================================================== */

  if(
    reduce ||
    !('IntersectionObserver' in window)
  ){

    trusts.forEach(function(section){

      section.classList.add(
        'nobl-trust-ready'
      );

      section
        .querySelectorAll(
          '.n3-trust__item'
        )
        .forEach(function(item){

          item.classList.add(
            'nobl-trust-item-in'
          );

        });

    });


    worlds.forEach(function(section){

      section.classList.add(
        'nobl-worlds-ready'
      );


      var header =
        section.querySelector(
          '[data-nobl-worlds-header]'
        );


      if(header){

        header.classList.add(
          'nobl-worlds-header-in'
        );

      }


      section
        .querySelectorAll(
          '[data-nobl-world-card]'
        )
        .forEach(function(card){

          card.classList.add(
            'nobl-world-card-in'
          );

        });

    });


    return;

  }



  /* ========================================================
     TRUST — WAIT UNTIL IT REACHES THE LOWER-MIDDLE VIEWPORT
     ======================================================== */

  trusts.forEach(function(section){

    if(
      section.dataset.noblTrustReady
      === 'true'
    ){
      return;
    }


    section.dataset.noblTrustReady =
      'true';


    section.classList.add(
      'nobl-trust-ready'
    );


    var items =
      Array.prototype.slice.call(
        section.querySelectorAll(
          '.n3-trust__item'
        )
      );


    /*
      Remove the older CSS delay so JS becomes
      the single timing authority.
    */

    items.forEach(function(item){

      item.style.setProperty(
        '--nobl-stagger',
        '0ms'
      );

    });


    var trustObserver =
      new IntersectionObserver(

        function(entries){

          entries.forEach(
            function(entry){

              if(!entry.isIntersecting){
                return;
              }
section.classList.add(
  'nobl-trust-active'
);

              items.forEach(
                function(item,index){

                  setTimeout(
                    function(){

                      item.classList.add(
                        'nobl-trust-item-in'
                      );

                    },

                    index * 140

                  );

                }
              );


              trustObserver.disconnect();

            }
          );

        },

        {
          threshold: 0,

          /*
            Bottom 32% of the viewport is excluded.
            The sequence therefore waits until the
            section is visibly entering the scene.
          */

          rootMargin:
            '0px 0px -32% 0px'
        }

      );


    trustObserver.observe(section);

  });



  /* ========================================================
     WORLDS — HEADER FIRST, THEN THE TWO WORLDS
     ======================================================== */

  worlds.forEach(function(section){

    if(
      section.dataset.noblWorldsReady
      === 'true'
    ){
      return;
    }


    section.dataset.noblWorldsReady =
      'true';


    section.classList.add(
      'nobl-worlds-ready'
    );


    var header =
      section.querySelector(
        '[data-nobl-worlds-header]'
      );


    var cards =
      Array.prototype.slice.call(
        section.querySelectorAll(
          '[data-nobl-world-card]'
        )
      );


    /*
      Again, JS owns the choreography.
    */

    cards.forEach(function(card){

      card.style.setProperty(
        '--nobl-world-stagger',
        '0ms'
      );

    });


    var worldsObserver =
      new IntersectionObserver(

        function(entries){

          entries.forEach(
            function(entry){

              if(!entry.isIntersecting){
                return;
              }


              /*
                01 — WORLD TITLE
              */

              if(header){

                header.classList.add(
                  'nobl-worlds-header-in'
                );

              }


              /*
                02 — NOBL
              */

              if(cards[0]){

                setTimeout(
                  function(){

                    cards[0].classList.add(
                      'nobl-world-card-in'
                    );

                  },
                  360
                );

              }


              /*
                03 — LADY NOBL
              */

              if(cards[1]){

                setTimeout(
                  function(){

                    cards[1].classList.add(
                      'nobl-world-card-in'
                    );

                  },
                  620
                );

              }


              /*
                Any future additional world cards.
              */

              if(cards.length > 2){

                cards
                  .slice(2)
                  .forEach(
                    function(card,index){

                      setTimeout(
                        function(){

                          card.classList.add(
                            'nobl-world-card-in'
                          );

                        },

                        820 +
                        (index * 180)

                      );

                    }
                  );

              }


              worldsObserver.disconnect();

            }
          );

        },

        {
          threshold: 0,

          rootMargin:
            '0px 0px -28% 0px'
        }

      );


    worldsObserver.observe(section);

  });



  /* ========================================================
     WORLDS — SUBTLE SCROLL DRIFT
     ======================================================== */

  if(!worlds.length){
    return;
  }


  var ticking = false;


  function updateWorlds(){

    worlds.forEach(function(section){

      var rect =
        section.getBoundingClientRect();


      var total =
        window.innerHeight
        +
        rect.height;


      var progress =
        (
          window.innerHeight
          -
          rect.top
        )
        /
        total;


      progress =
        Math.max(
          0,
          Math.min(
            1,
            progress
          )
        );


      /*
        Roughly ±10px travel.
        Visible, but still luxury-level restraint.
      */

      var shift =
        (
          (progress - .5)
          *
          -20
        ).toFixed(2)
        +
        'px';


      section.style.setProperty(
        '--nobl-worlds-shift',
        shift
      );

    });


    ticking = false;

  }


  function requestWorlds(){

    if(ticking){
      return;
    }


    ticking = true;


    requestAnimationFrame(
      updateWorlds
    );

  }


  window.addEventListener(
    'scroll',
    requestWorlds,
    { passive: true }
  );


  window.addEventListener(
    'resize',
    requestWorlds
  );


  updateWorlds();


}function initProductExhibit(){

  var manifesto =
    document.querySelector(
      '[data-nobl-manifesto]'
    );

  var featured =
    document.querySelector(
      '[data-nobl-featured]'
    );


  /* MANIFESTO */

  if(manifesto){

    manifesto.classList.add(
      'nobl-manifesto-ready'
    );


    var eyebrow =
      manifesto.querySelector(
        '.n3-eye'
      );

    var statement =
      manifesto.querySelector(
        '.n3-manifesto__line'
      );

    var signature =
      manifesto.querySelector(
        '.n3-manifesto__sig'
      );


    var manifestoObserver =
      new IntersectionObserver(
        function(entries){

          entries.forEach(function(entry){

            if(!entry.isIntersecting){
              return;
            }


            if(eyebrow){

              eyebrow.classList.add(
                'nobl-manifesto-in'
              );

            }


            if(statement){

              setTimeout(function(){

                statement.classList.add(
                  'nobl-manifesto-in'
                );

              },180);

            }


            if(signature){

              setTimeout(function(){

                signature.classList.add(
                  'nobl-manifesto-in'
                );

              },420);

            }


            manifestoObserver.disconnect();

          });

        },
        {
          threshold: 0,
          rootMargin:
            '0px 0px -28% 0px'
        }
      );


    manifestoObserver.observe(
      manifesto
    );

  }



  /* FEATURED PRODUCT EXHIBIT */

  if(featured){

    featured.classList.add(
      'nobl-featured-ready'
    );


    var header =
      featured.querySelector(
        '[data-nobl-featured-header]'
      );


    var cards =
      Array.prototype.slice.call(
        featured.querySelectorAll(
          '[data-nobl-product-card]'
        )
      );


    var featuredObserver =
      new IntersectionObserver(
        function(entries){

          entries.forEach(function(entry){

            if(!entry.isIntersecting){
              return;
            }


            if(header){

              header.classList.add(
                'nobl-featured-header-in'
              );

            }


            cards.forEach(
              function(card,index){

                setTimeout(
                  function(){

                    card.classList.add(
                      'nobl-product-card-in'
                    );

                  },

                  260 + (index * 120)

                );

              }
            );


            featuredObserver.disconnect();

          });

        },
        {
          threshold: 0,
          rootMargin:
            '0px 0px -20% 0px'
        }
      );


    featuredObserver.observe(
      featured
    );

  }

}
  function initPageTransitions(){

  var root = document.documentElement;

  function clearLeavingState(){
    root.classList.remove('nobl-is-leaving');
  }


  /* ============================================================
     ALWAYS CLEAR A STALE TRANSITION ON PAGE INITIALIZATION
     ============================================================ */

  clearLeavingState();


  window.addEventListener(
    'pageshow',
    clearLeavingState
  );


  window.addEventListener(
    'load',
    clearLeavingState
  );


  document.addEventListener(
    'visibilitychange',
    function(){
      if(document.visibilityState === 'visible'){
        clearLeavingState();
      }
    }
  );


  /* ============================================================
     SHOPIFY THEME EDITOR SAFETY
     Theme Editor can reload sections without firing pageshow.
     Never allow the black transition overlay to remain active.
     ============================================================ */

  if(
    window.Shopify &&
    Shopify.designMode
  ){

    document.addEventListener(
      'shopify:section:load',
      clearLeavingState
    );

    document.addEventListener(
      'shopify:section:select',
      clearLeavingState
    );

    document.addEventListener(
      'shopify:section:deselect',
      clearLeavingState
    );

    document.addEventListener(
      'shopify:block:select',
      clearLeavingState
    );

    return;
  }


  /* ============================================================
     FRONT-END PAGE TRANSITIONS
     ============================================================ */

  if(
    reduce ||
    body.dataset.noblPageTransitions !== 'true'
  ){
    return;
  }


  document.addEventListener(
    'click',
    function(e){

      var a =
        e.target.closest &&
        e.target.closest('a[href]');

      if(!eligibleLink(a,e)){
        return;
      }


      e.preventDefault();

      var href = a.href;


      root.classList.add(
        'nobl-is-leaving'
      );


      var raw =
        getComputedStyle(body)
        .getPropertyValue(
          '--nobl-page-transition-ms'
        );


      var ms =
        parseInt(raw,10) ||
        420;


      setTimeout(
        function(){
          location.href = href;
        },
        Math.max(
          180,
          Math.min(ms,700)
        ) * .72
      );

    },
    false
  );

}

  function init(){
  initReveals();
  initEnvironment();
  initHeroMotion();
  initJourneyBridge();
  initProductExhibit();
  initPageTransitions();
}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
